import { Button, Title } from '@qonsoll/react-design'
import { Checkbox, Form, Input, InputNumber } from 'antd'
import { KEYS, MAX_LENGTH_DESCRIPTION, MAX_LENGTH_FIELD } from '__constants__'

import { ImageUploader } from 'components'
import PropTypes from 'prop-types'
import { onTextAreaEnterPress } from 'helpers'
import { useTranslations } from 'contexts/Translation'

const StoreSimpleForm = (props) => {
  const { initialValues, onSubmit, onCancel, showTitle, form, group } = props

  /* Getting translations instance */
  const { t } = useTranslations()
  /* Getting new form instance from Form.useForm hook */
  const [baseForm] = Form.useForm()

  /* Getting used form from props or using base form */
  const usedForm = form || baseForm

  /* Resetting form on cancel */
  const handleCancel = () => {
    usedForm.resetFields()
    onCancel?.()
  }
  /* Submitting form on enter key press */
  const handleKeyPress = (e) => {
    if (e.key === KEYS.ENTER) {
      e.preventDefault()
      e.stopPropagation()
      usedForm?.submit()
    }
  }

  return group ? (
    <>
      {showTitle && (
        <Title level={4} mb={2}>
          {t('Store')}
        </Title>
      )}
      <Form.Item label={t('Image')} name={[...group, 'logoUrl']}>
        <ImageUploader />
      </Form.Item>
      <Form.Item
        label={t('Name')}
        name={[...group, 'name']}
        rules={[
          {
            required: true,
            message: t('Please enter your store name!')
          },
          { max: MAX_LENGTH_FIELD, message: t('store name is too long!') }
        ]}>
        <Input placeholder={t('Please enter your store name')} />
      </Form.Item>
      <Form.Item
        label={t('Description')}
        name={[...group, 'description']}
        rule={[
          {
            max: MAX_LENGTH_DESCRIPTION,
            message: t('Store description is too long!')
          }
        ]}>
        <Input.TextArea
          onPressEnter={onTextAreaEnterPress}
          placeholder={t('Please enter you store description')}
        />
      </Form.Item>
    </>
  ) : (
    <Form
      form={usedForm}
      initialValues={initialValues}
      onFinish={onSubmit}
      layout="vertical"
      onKeyPress={handleKeyPress}
      autoComplete="off">
      {showTitle && (
        <Title level={4} mb={2}>
          {t('Store')}
        </Title>
      )}
      <Form.Item
        label={t('Name')}
        name="name"
        rules={[
          {
            required: false,
            message: t('Please enter your store name!')
          },
          { max: MAX_LENGTH_FIELD, message: t('store name is too long!') }
        ]}>
        <Input placeholder={t('Please enter your store name')} />
      </Form.Item>
      <Form.Item
        label={t('Sno')}
        name="sno"
        rules={[
          {
            required: false,
            message: t('Please enter your store sno!')
          }
        ]}>
        <InputNumber placeholder={t('Please enter your store sno')} />
      </Form.Item>
      <Form.Item
        label={t('Total coupons')}
        name="totalCoupons"
        rules={[
          {
            required: false,
            message: t('Please enter your store total coupons!')
          }
        ]}>
        <InputNumber placeholder={t('Please enter your store total coupons')} />
      </Form.Item>
      <Form.Item
        label={t('Redeemed')}
        name="redeemed"
        valuePropName="checked"
        initialValue={false} // TODO fix initial value
        rules={[
          {
            required: false,
            message: t('Please enter your store redeemed!')
          }
        ]}>
        <Checkbox placeholder={t('Please enter your store redeemed')} />
      </Form.Item>
      {!form && (
        <>
          <Button mr={2} htmlType="button" onClick={handleCancel}>
            {t('Cancel')}
          </Button>
          <Button type="primary" onClick={() => usedForm.submit()}>
            {t('Save')}
          </Button>
        </>
      )}
    </Form>
  )
}

StoreSimpleForm.propTypes = {
  initialValues: PropTypes.object,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  showTitle: PropTypes.bool,
  form: PropTypes.any,
  group: PropTypes.array
}

export default StoreSimpleForm
